<nav>
    <ul>
        <li><a routerLink="/">Dashboard</a></li>
        <li><a routerLink="/landing-pages">Landing pages</a></li>
        <li><a routerLink="/blogposts">Blogposts</a></li>
        <li><a routerLink="/links">Links</a></li>
        <li><a routerLink="/images">Images</a></li>
        <li><a routerLink="/galleries">Galleries</a></li>
    </ul>
</nav>
